export default __webpack_public_path__ + "static/media/bannerBgMb.7fd257a8.png";